import dayjs from '~/timeInit';

import { validDay } from './liveDataAdapter';

export function reportDateRange(from?: string | null, to?: string | null) {
  const date = (value?: string | null) =>
    value && validDay(value) ? dayjs(value).format('D MMM YYYY') : 'Not supplied';
  return `${date(from)} – ${date(to)}`;
}

export const REPORT_FILTER_DEFAULTS = {
  refund: 'Before Refund',
  currency: 'AUD',
  period: 'Full Period',
  room: 'All',
  packageType: 'All',
  booking: 'All',
  axisStart: '0',
  axisDays: '0',
};

export function reportFilterDraft(params: URLSearchParams, currency: string): Record<string, string> {
  const draft: Record<string, string> = {
    ...REPORT_FILTER_DEFAULTS,
    currency,
    from: '',
    to: '',
    cmpFrom: '',
    cmpTo: '',
  };
  for (const key of Object.keys(draft)) draft[key] = params.get('fp' + key) ?? draft[key];
  return draft;
}

/** Keep implicit defaults implicit so presentation edits do not redo analytical work. */
export function reportFilterChanges(initial: Record<string, string>, draft: Record<string, string>) {
  return Object.fromEntries(Object.entries(draft).filter(([key, value]) => value !== initial[key]));
}

export function reportFilterProblem(draft: Record<string, string>, cutoff: string, comparison: boolean) {
  for (const [from, to] of [['from', 'to'], ...(comparison ? [['cmpFrom', 'cmpTo']] : [])]) {
    if (!validDay(draft[from]) || !validDay(draft[to]) || draft[from] > draft[to])
      return 'Choose valid dates with the start before the end.';
    if (draft[to] > cutoff) return 'Reporting dates must end on or before the last completed Sydney day.';
  }
  if (!['axisStart', 'axisDays'].every((key) => /^\d+$/.test(draft[key]) && Number.isSafeInteger(Number(draft[key]))))
    return 'Choose whole chart days starting from zero.';
  if (Number(draft.axisDays) > 0 && Number(draft.axisDays) < Number(draft.axisStart))
    return 'Chart end day must follow its start day.';
  return '';
}
